// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo_4r9d4PUFrI","subTitle":"subTitle_Fle9mEoblk","arrow":"arrow_1a5KnzYvib","arrowLeft":"arrowLeft_3zmqhiPLm-","arrowRight":"arrowRight_3nzEzyW6u2"};